import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// ফন্ট নিজেদের সার্ভার থেকে (Google Fonts-এ কোনো রিকোয়েস্ট যায় না) — unicode-range আছে, তাই ব্রাউজার
// শুধু বাংলা/ল্যাটিনের যে অংশ লাগে সেটাই নামায়।
import '@fontsource/hind-siliguri/400.css'
import '@fontsource/hind-siliguri/500.css'
import '@fontsource/hind-siliguri/600.css'
import '@fontsource/noto-serif-bengali/600.css'
import '@fontsource/noto-serif-bengali/700.css'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
